/**
 * Cart Auto-Gift Manager v13 (09-12 ladder: gift at 4 pairs, only the qualifying product type counts)
 * - Loading overlay blocks cart during gift sync
 * - Optimized: batch operations, skip redundant fetches
 * - Instant response interception (no debounce/cooldown)
 */
(function () {
  'use strict';

  var GIFT_CONFIG = {
    giftVariantId: 47200469352681,
    giftProductId: 8565589541097,
    excludedProductTypes: [],
    qualifyingType: 'Foot Alignment Socks',
    tiers: [
      { minQty: 4, giftCount: 2 }
    ]
  };

  /* Load config from Liquid-rendered JSON */
  try {
    var cfgEl = document.getElementById('cart-gift-config');
    if (cfgEl) {
      var cfgArr = JSON.parse(cfgEl.textContent);
      if (cfgArr && cfgArr[0]) {
        var cfg = cfgArr[0];
        if (cfg.giftVariantId) GIFT_CONFIG.giftVariantId = cfg.giftVariantId;
        if (cfg.giftProductId) GIFT_CONFIG.giftProductId = cfg.giftProductId;
        if (cfg.excludedProductTypes) {
          GIFT_CONFIG.excludedProductTypes = cfg.excludedProductTypes
            .split(',').map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
        }
        if (cfg.tiers) GIFT_CONFIG.tiers = cfg.tiers;
        if (cfg.qualifyingType !== undefined) GIFT_CONFIG.qualifyingType = cfg.qualifyingType || '';
      }
    }
  } catch(e) {}

  var _isProcessing = false;
  var _originalFetch = window.fetch;

  function log() {
    var args = ['%c[CartGift]', 'color: #28a745; font-weight: bold;'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  var CART_MUTATION_RE = /\/cart\/(add|update|change)(\.js)?/;

  /* ── Overlay ── */
  var _overlayTimer = null;
  var _waitingForRender = false;

  function showOverlay(ms) {
    clearTimeout(_overlayTimer);
    var el = document.getElementById('bw-cart-overlay');
    if (el) el.style.display = 'flex';
    /* Safety fallback: 4 s for a plain theme update, 9 s when WE add/remove gifts (3G: add ~2.5 s + re-render ~2 s).
       Clearing _isProcessing here is what un-wedges a session whose gift request never came back. */
    _overlayTimer = setTimeout(function () { _isProcessing = false; hideOverlay(); }, ms || 4000);
  }
  function hideOverlay() {
    clearTimeout(_overlayTimer);
    _waitingForRender = false;
    var el = document.getElementById('bw-cart-overlay');
    if (el) el.style.display = 'none';
  }

  /* Back-cache restore (iOS back from checkout) can bring the page back with the overlay painted:
     hide it and re-sync the gift count from the real cart. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    _isProcessing = false;
    hideOverlay();
    _originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { syncFromCartData(c, 'pageshow'); }).catch(function () {});
  });

  /* theme:cart:change = theme finished its own update cycle.
     Only hide if we are NOT processing gifts AND NOT waiting for re-render. */
  document.addEventListener('theme:cart:change', function() {
    if (!_isProcessing && !_waitingForRender) {
      hideOverlay();
    }
  });

  /* theme:product:added = theme finished re-rendering cart after refresh.
     This is where we hide after gift sync + re-render is complete. */
  document.addEventListener('theme:product:added', function() {
    if (_waitingForRender) {
      hideOverlay();
    }
  });

  /* ── Calculate expected gifts ── */
  function calcFromCart(cart) {
    var items = cart.items || [];
    var qualifyingQty = 0;
    var giftItems = [];
    var currentGiftQty = 0;

    items.forEach(function (item) {
      var isFreeGift = item.properties &&
        (item.properties['_bundle_free'] === 'true' || item.properties['_auto_gift'] === 'true');
      var isGiftProduct = item.product_id === GIFT_CONFIG.giftProductId;

      if (isGiftProduct && isFreeGift) {
        giftItems.push(item);
        currentGiftQty += item.quantity;
      } else if (!isGiftProduct) {
        var excluded = false;
        for (var j = 0; j < GIFT_CONFIG.excludedProductTypes.length; j++) {
          if (item.product_type === GIFT_CONFIG.excludedProductTypes[j]) { excluded = true; break; }
        }
        if (GIFT_CONFIG.qualifyingType && item.product_type !== GIFT_CONFIG.qualifyingType) excluded = true;
        if (!excluded) qualifyingQty += item.quantity;
      }
    });

    var expectedGifts = 0;
    var matchedTier = null;
    for (var i = 0; i < GIFT_CONFIG.tiers.length; i++) {
      if (qualifyingQty >= GIFT_CONFIG.tiers[i].minQty) {
        expectedGifts = GIFT_CONFIG.tiers[i].giftCount;
        matchedTier = GIFT_CONFIG.tiers[i];
        break;
      }
    }

    return {
      qualifyingQty: qualifyingQty,
      currentGiftQty: currentGiftQty,
      expectedGifts: expectedGifts,
      giftItems: giftItems,
      matchedTier: matchedTier
    };
  }

  /* ── Sync gifts ── */
  function syncFromCartData(cart, source) {
    if (_isProcessing) return;

    var c = calcFromCart(cart);
    log(source + ': qualifying=' + c.qualifyingQty, 'current=' + c.currentGiftQty, 'expected=' + c.expectedGifts);

    if (c.currentGiftQty === c.expectedGifts) {
      /* Gifts correct — just ensure attributes are right */
      if (c.expectedGifts > 0) syncAttributes(c, false);
      return;
    }

    /* Gifts need changing — show overlay immediately */
    _isProcessing = true;
    showOverlay(9000);

    if (c.currentGiftQty < c.expectedGifts) {
      addGifts(c.expectedGifts - c.currentGiftQty, c);
    } else {
      removeGifts(c.giftItems, c.currentGiftQty - c.expectedGifts, c);
    }
  }

  /* ── Set bundle tracking attributes (non-blocking) ── */
  function syncAttributes(c, clearing) {
    if (clearing) {
      _originalFetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: {
          '_dirts_bundle': '', '_dirts_bundle_tier': '',
          '_dirts_bundle_source': '', '_dirts_bundle_product': ''
        }})
      }).catch(function(){});
      return;
    }
    var tierLabel = c.matchedTier ? 'buy-' + c.matchedTier.minQty + '-get-' + c.matchedTier.giftCount : 'unknown';
    _originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var attrs = cart.attributes || {};
        var newAttrs = { '_dirts_bundle': 'true', '_dirts_bundle_tier': tierLabel };
        if (!attrs['_dirts_bundle_source']) {
          newAttrs['_dirts_bundle_source'] = 'cart-accumulation';
          newAttrs['_dirts_bundle_product'] = 'mixed';
        }
        _originalFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: newAttrs })
        }).catch(function(){});
      }).catch(function(){});
  }

  /* ── Add gifts ── */
  function addGifts(count, calcResult) {
    log('Adding', count, 'gifts');
    _originalFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_CONFIG.giftVariantId, quantity: count,
          properties: { '_auto_gift': 'true', '_bundle_free': 'true' } }]
      })
    })
    .then(function () {
      syncAttributes(calcResult, false);
      _isProcessing = false;
      _waitingForRender = true; /* Keep overlay until cart re-renders */
      refreshCart(); /* triggers theme:cart:refresh → getCart → build → theme:product:added */
    })
    .catch(function (err) {
      console.error('[CartGift] addGifts ERROR:', err);
      _isProcessing = false;
      hideOverlay();
    });
  }

  /* ── Remove gifts ── */
  function removeGifts(giftItems, removeCount, calcResult) {
    var updates = {};
    var removed = 0;
    for (var i = 0; i < giftItems.length; i++) {
      if (removed >= removeCount) break;
      var item = giftItems[i];
      var toRemove = Math.min(item.quantity, removeCount - removed);
      updates[item.key] = item.quantity - toRemove;
      removed += toRemove;
    }
    log('Removing', removeCount, 'gifts');
    _originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function () {
      /* Check if all gifts gone — clear attributes */
      var remaining = 0;
      giftItems.forEach(function(gi) { remaining += (updates[gi.key] || 0); });
      if (remaining === 0 && calcResult.expectedGifts === 0) {
        syncAttributes(null, true);
      }
      _isProcessing = false;
      _waitingForRender = true; /* Keep overlay until cart re-renders */
      refreshCart();
    })
    .catch(function (err) {
      console.error('[CartGift] removeGifts ERROR:', err);
      _isProcessing = false;
      hideOverlay();
    });
  }

  /* ── Refresh cart UI (single event, no extra fetches) ── */
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    /* Update cart count badge */
    _originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        document.querySelectorAll('cart-count').forEach(function (el) { el.setAttribute('data-count', cart.item_count); });
      }).catch(function () {});
  }

  /* ── Intercept fetch ── */
  window.fetch = function () {
    var url = arguments[0];
    var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
    var isCartMutation = CART_MUTATION_RE.test(urlStr);

    if (isCartMutation && !_isProcessing) {
      showOverlay(); /* Block checkout immediately */
    }

    var result = _originalFetch.apply(this, arguments);

    if (isCartMutation && !_isProcessing) {
      return result.then(function (response) {
        var cloned = response.clone();
        /* Hold the response — run sync check BEFORE returning to theme.
           This guarantees _isProcessing is set before theme fires events. */
        return cloned.json().then(function (data) {
          if (data && data.items && data.item_count !== undefined) {
            syncFromCartData(data, 'fetch-response');
          } else {
            /* /cart/add.js returns line item, not full cart — need follow-up */
            return _originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                syncFromCartData(cart, 'fetch-add-followup');
                return response;
              });
          }
          return response;
        }).catch(function () { return response; });
      });
    }
    return result;
  };

  /* ── Intercept XHR (prototype patch) ── */
  var _origXHROpen = XMLHttpRequest.prototype.open;
  var _origXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._bw_url = typeof url === 'string' ? url : String(url || '');
    return _origXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (CART_MUTATION_RE.test(self._bw_url) && !_isProcessing) {
      self.addEventListener('load', function () {
        if (self.readyState === 4 && self.status >= 200 && self.status < 400) {
          try {
            var data = JSON.parse(self.responseText);
            if (data && data.items && data.item_count !== undefined) {
              syncFromCartData(data, 'xhr-response');
            } else {
              _originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) { syncFromCartData(cart, 'xhr-followup'); })
                .catch(function () {});
            }
          } catch (e) {}
        }
      });
    }
    return _origXHRSend.apply(this, arguments);
  };

  /* ── Initial sync ── */
  log('v13 loaded — ladder: gift at', GIFT_CONFIG.tiers[0] && GIFT_CONFIG.tiers[0].minQty);
  _originalFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) { syncFromCartData(cart, 'init'); })
    .catch(function () {});
})();
